import React from 'react';
import { useHistory } from 'react-router-dom';
import Smile from '../../assets/images/smille.svg';
import { Button, Text } from '@chakra-ui/core';

import { Container, Content } from './styles';

const Begin: React.FC = () => {
  const history = useHistory();
  return (
    <Container>
      <Content>
        <div className="img" />
        <div>
          <img src={Smile} alt='smille' />
          <Text fontSize='4xl' color='#424242' marginBottom='10px'>
            TUDO PRONTO!
          </Text>
          <Text color='white' textAlign='center'>
            Se você chegou até aqui, significa que gostaria de retornar a sua localidade nesse momento!
          </Text>
          <Text color='white' textAlign='center'>
            Como forma de confirmar sua descisão de forma livre e voluntária é necessário que preencha, o formulário de
            inscrição!
          </Text>
          <Text color='white' textAlign='center' marginTop='20px'>
            Lembramos que na primeira fase, iremos liberar somente 10% das posições!
          </Text>
          <Button onClick={() => { history.push('/cadastro') }} variantColor='#424242' backgroundColor='#424242' paddingX={10} marginTop='30px'>
            QUERO ME INSCREVER!
          </Button>
        </div>
      </Content>
    </Container>
  );
};

export default Begin;
